import { useTheme } from '@mui/material/styles';
import { styleConstants } from '../../Utils/styleConsts';
export const useStyles = () => {
    const theme = useTheme();
    const styles = {
        root: {
            marginTop: theme.spacing(2),
            alignItems: 'flex-end',
            justifyContent: 'space-between',
            display: 'flex',
        },
        stickyInMobile: {
            [theme.breakpoints.down('xs')]: {
                display: 'flex',
                position: 'fixed',
                bottom: 0,
                left: 0,
                padding: ` ${theme.spacing(1)} ${theme.spacing(2)}`,
                zIndex: 2,
                width: '100vw',
                backgroundColor: theme.palette.grey[50],
                borderTop: '1px solid',
                borderColor: theme.palette.grey[200],
                borderTopRightRadius: theme.shape.borderRadius,
                borderTopLeftRadius: theme.shape.borderRadius,
            },
        },
        forward: {
            marginLeft: 'auto',
            [theme.breakpoints.down('xs')]: {
                flexGrow: 1,
            },
            textTransform: styleConstants.buttonTextTransform,
            fontSize: styleConstants.buttonFontSize,
            fontWeight: styleConstants.buttonFontWeight,
            padding: styleConstants.buttonPadding,
        },
        goBackLink: {
            marginRight: theme.spacing(1),
            textTransform: styleConstants.buttonTextTransform,
            fontSize: styleConstants.buttonFontSize,
            fontWeight: styleConstants.buttonFontWeight,
            padding: styleConstants.buttonPadding,
        },
    };
    return styles;
};
